import { Instance } from "../axios";

// export class commonService {
//     static fetchListing = (req) => {
//         return (dispatch) => {
//             Instance.get(req)
//                 .then((res) => {
//                     // console.log(" ~ res:", res)
//                     dispatch(messageText(res.data.message));

//                     if (res.data.status === 200) {
//                         return res.data.data
//                     } else {
//                         return res.data = []
//                     }
//                 }).catch((error) => {
//                     console.log(" error:", error)
//                     // dispatch(loginError("Login error"));
//                 });
//         }
//     };
// }

export const fetchListing = async (params) => {
    return await Instance.get(params)
        .then((res) => {
            if (res?.data) {
                return res?.data
            } else {
                return res?.response?.data
            }
        })
        .catch((error) => console.log(error))
};

export const info = async (params) => {
    return await Instance.get(`${params + "?editable=true"}`)
        .then((res) => {
            if (res.data) {
                return res.data
            } else {
                return res.response.data
            }
        })
        .catch((error) => console.log(error))
};

export const infoWithMoreParams = async (params) => {
    return await Instance.get(`${params + "editable=true"}`)
        .then((res) => {
            if (res.data) {
                return res.data
            } else {
                return res.response.data
            }
        })
        .catch((error) => console.log(error))
};

export const getById = async (params) => {
    return await Instance.get(params)
        .then((res) => {
            if (res.data) {
                return res.data
            } else {
                return res.response.data
            }
        })
        .catch((error) => console.log(error))
};

export const cancelEditing = async (params) => {
    return await Instance.get(params)
        .then((res) => {
            if (res.data) {
                return res.data
            } else {
                return res.response.data
            }
        })
        .catch((error) => console.log(error))
};

export const addRec = async (params, data) => {
    return await Instance.post(params, data)
        .then((res) => {
            if (res.data) {
                return res.data
            } else {
                return res.response.data
            }
        })
        .catch((error) => console.log(error))
};

export const downLoadFile = async (params, data) => {
    return await Instance.post(params, data, {
        responseType: 'arraybuffer',
    }).then((res) => {
        if (res) {
            return res
        }
    }).catch((error) => console.log(error))
};

export const editRec = async (params, data) => {
    return await Instance.put(params, data)
        .then((res) => {
            if (res.data) {
                return res.data
            } else {
                return res.response.data
            }
        })
        .catch((error) => console.log(error))
};

export const editRecParamsOnly = async (params) => {
    return await Instance.put(params)
        .then((res) => {
            if (res.data) {
                return res.data
            } else {
                return res.response.data
            }
        })
        .catch((error) => console.log(error))
};

export const deleteRec = async (params) => {
    return await Instance.delete(params)
        .then((res) => {
            if (res.data) {
                return res.data
            } else {
                return res.response.data
            }
        })
        .catch((error) => console.log(error))
};
